<template>
    <div class="page-wrapper">
        <div class="container-fluid">
            <div class="right-sidebar ps ps--theme_default settings-section"
                :class="{ 'shw-rside': this.sidebarCollapse.settings_menu }">
                <div class="slimscrollright">
                    <div class="rpanel-title">
                        {{ $t('setting') }} <span @click="() => collapseSidebar('settings_menu')"><i
                                class="ti-close right-side-toggle"></i></span>
                    </div>
                    <div class="r-panel-body user-info">
                        <div class="text-left">
                            <img :src="currentUserImage()" alt="user" class />
                            <span class="user-info-name">
                                <router-link :to="{ name: 'profile' }">
                                    <p>
                                        {{ currentUser.name ? currentUser.name : currentUser.email }} - {{
                                        currentUser.role }}
                                    </p>
                                    <p v-if="currentUser.role != 'PREMIUM'">
                                        <link-button :classes="['btn-cyan']" :to="{ name: 'upgrade' }">
                                            <i class="far fa-star"></i> {{ $t('buttons.upgrade') }}
                                        </link-button>
                                    </p>
                                </router-link>
                            </span>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="text-left">
                            <label>{{ $t('language') }}</label>
                            <input-select :value="defaultLocale" name="sectors" class="m-0" :options="languageOptions"
                                @input="value => selectLanguage(value)" />
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="text-left">
                            <a @click="() => authLogout()" class="cursor-pointer">
                                <i class="fa fa-power-off"></i> {{ $t('logout') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Profile',
    
}
</script>